module.exports = __webpack_public_path__ + "img/step01_c_locate_elements.6f261910.png";